/* eslint-disable */
import { useEffect, useState, useMemo } from "react";
import LoadingDots from "../../components/domains/loading-dots";
import { Copy, Check } from "lucide-react";
import DomainCard from "../../components/domains/domain-card";
import { Modal, Table } from "antd";
import { RiCloseFill } from "react-icons/ri";
import Sidebar from "../../components/sidebar/Sidebar2";
import Navbar from "../../components/navbar/Navbar2";
import Footer from "../../components/footer/Footer";
import {
  collection,
  doc,
  getDocs,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "../../firebase";
import { useSelector } from "react-redux";
import checkDomain from "../../api/checkDomain";
import addNewDomain from "../../api/addDomain";
import { AlertCircle, Info } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Domains() {
  // Déclarations d'états (hooks appelés inconditionnellement)
  const [showSideBar, setShowSideBar] = useState(true);
  const [domain, setDomain] = useState("");
  const [adding, setAdding] = useState(false);
  const [storeErrorMessage, setStoreErrorMessage] = useState("");
  const [domainStatus, setDomainStatus] = useState({
    configured: false,
    verified: false,
    loading: true,
  });
  const navigate = useNavigate();
  const [firebaseAccountData, setFirebaseAccountData] = useState({});
  const [existingDomain, setExistingDomain] = useState("");
  const [domainName, setdomainName] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";

  // Récupération du compte depuis Redux
  const account = useSelector((state) => state.AccountReducer);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // 1) Vérifier localement et côté cloud si le nom de domaine est déjà pris
  const checkStoreNameUniqueness = async (storeName) => {
    const regex = /[^a-zA-Z0-9-]|-$/;
    const store = getSecondLevelDomain(storeName);
    const domaincheck = getSecondLevelDomain(domain);
    if (domaincheck === store) return true;

    if (regex.test(store)) {
      setStoreErrorMessage(
        "الرجاء عدم استخدام الشرطات في نهاية النص أو استخدام محارف غير مسموح بها"
      );
      return false;
    }

    try {
      const response = await fetch(
        `https://us-central1-e-commerce-17eb9.cloudfunctions.net/checkstorename?storeName=${store}`
      );
      if (!response.ok) {
        throw new Error("حدث خطأ أثناء التحقق من الاسم.");
      }
      const data = await response.json();
      if (!data.unique) {
        setStoreErrorMessage("هذا الاسم موجود بالفعل، يرجى التواصل مع الدعم");
        return false;
      } else {
        setStoreErrorMessage("");
        return true;
      }
    } catch (error) {
      console.error("Error checking uniqueness: ", error);
      setStoreErrorMessage("حدث خطأ أثناء التحقق من الاسم.");
      return false;
    }
  };

  // 2) Charger le domaine existant depuis Firebase
  const getExistingDomain = () => {
    if (!account) return;

    let editedDomain = account?.storeName
      ?.replace("https://", "")
      .replace("www", "");

    if (editedDomain?.endsWith("/")) {
      editedDomain = editedDomain.slice(0, -1);
    }

    let fireDomainName = account?.store
      ?.replace("https://", "")
      .replace("/", "");

    setExistingDomain(editedDomain || "");
    setdomainName(fireDomainName || "");
    setFirebaseAccountData({ ...account }); // مباشرة من Redux
  };

  // 3) Vérifier le statut d'un domaine via checkDomain (Vercel)
  const getDomainStatus = async () => {
    if (!domainName) return;

    setDomainStatus((prev) => ({ ...prev, loading: true }));

    try {
      const res = await fetch("https://backend.foorweb.shop/api/checkDomain", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ domain: domainName }),
      });

      const result = await res.json();

      if (res.ok && result?.configured && result?.verified) {
        await updateDoc(doc(db, "account", account?.id), {
          confirmDomain: true,
        });
      }

      setDomainStatus({
        configured: result?.configured || false,
        verified: result?.verified || false,
        loading: false,
      });
    } catch (err) {
      console.error("Erreur lors de la vérification du domaine :", err);
      setDomainStatus((prev) => ({ ...prev, loading: false }));
    }
  };

  useEffect(() => {
    getExistingDomain();
  }, [account]);

  useEffect(() => {
    if (domainName) {
      getDomainStatus();
    }
  }, [domainName]);

  // Utilitaire pour extraire le deuxième niveau d'un domaine
  const getSecondLevelDomain = (url) => {
    const parts = url.split(".");
    return parts.slice(-2, -1).join(".") || "";
  };
  const goToUpgrade = () => {
    navigate("/plan");
  };

  // 4) Mettre à jour Firebase avec le nouveau domaine
  const AddDomain = async () => {
    try {
      const domainData = {
        domain: `https://${domain}/`,
        store: `https://${domain}/`,
        storeName: `https://${getSecondLevelDomain(domain)}.foorweb.store/`,
      };

      if (!account?.id) {
        console.error("Erreur : ID du document Firebase introuvable !");
        return;
      }
      await updateDoc(doc(db, "account", account?.id), {
        ...domainData,
      });
      getExistingDomain();
    } catch (err) {
      console.error("Erreur lors de l'ajout du domaine:", err);
    } finally {
      setDomain("");
      setAdding(false);
    }
  };

  const handleAddDomain = async () => {
    setAdding(true);
    setStoreErrorMessage("");

    try {
      const isUnique = await checkStoreNameUniqueness(domain);
      if (!isUnique) {
        setAdding(false);
        return;
      }

      let res = await fetch("https://backend.foorweb.shop/api/checkDomain", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ domain }),
      });
      let result = await res.json();
      if (!result?.existsOnVercel) {
        const addRes = await fetch(
          "https://backend.foorweb.shop/api/addDomain",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ domain }),
          }
        );

        if (!addRes.ok) {
          const error = await addRes.json();
          throw new Error(error?.error || "Erreur lors de l'ajout du domaine");
        }

        await new Promise((res) => setTimeout(res, 3000));

        res = await fetch("https://backend.foorweb.shop/api/checkDomain", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ domain }),
        });
        result = await res.json();
      }

      if (result?.existsOnVercel) {
        await AddDomain();
        setdomainName(domain);
      }
    } catch (err) {
      console.error("Erreur lors de la vérification :", err);
      alert(t("ui.domainVerifyError"));
    }

    setAdding(false);
  };

  const showModal = () => setIsModalVisible(true);
  const handleOk = () => setIsModalVisible(false);
  const handleCancel = () => setIsModalVisible(false);

  const rtlStyle = {
    direction: i18n.dir(),
    textAlign: i18n.dir() === "rtl" ? "right" : "left",
  };
  const [copiedIndex, setCopiedIndex] = useState(null);

  const handleCopy = (text, index) => {
    // طريقة بديلة للنسخ تخدم في كل البيئات
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    textArea.style.left = "-999999px";
    textArea.style.top = "-999999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand("copy");
      setCopiedIndex(index);
      setTimeout(() => setCopiedIndex(null), 2000);
    } catch (err) {
      console.error("فشل النسخ:", err);
    }

    document.body.removeChild(textArea);
  };

  const dataSource = [
    { key: "1", Type: "Name Servers", Value: "ns1.vercel-dns.com" },
    { key: "2", Type: "Name Servers", Value: "ns2.vercel-dns.com" },
  ];

  const columns = [
    {
      title: "Type",
      dataIndex: "Type",
      key: "Type",
      className: "font-medium",
    },
    {
      title: "Value",
      dataIndex: "Value",
      key: "Value",
      render: (text, record, index) => (
        <div className="flex items-center justify-between gap-2">
          <span className="font-mono text-sm">{text}</span>
          <button
            onClick={() => handleCopy(text, index)}
            className="p-2 hover:bg-purple-50 dark:hover:bg-purple-900/20 rounded-lg transition-colors flex items-center gap-1"
            title={t("services.printAgent.copy")}
          >
            {copiedIndex === index ? (
              <>
                <Check size={16} className="text-green-600" />
                <span className="text-xs text-green-600">{t("servicePageActivation.orderMessages.alerts.copySuccess.title")}</span>
              </>
            ) : (
              <Copy
                size={16}
                className="text-gray-600 dark:text-gray-400 hover:text-[#9e68ba] dark:hover:text-purple-400"
              />
            )}
          </button>
        </div>
      ),
    },
  ];

  return (
    <div
      className="container-fluid bg-purple-50 dark:!bg-[#141414] min-h-screen"
      dir={isRTL ? "rtl" : "ltr"}
    >
      <div className="row">
        {showSideBar && (
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              transition: "width 0.6s ease",
              boxShadow: "2px 0 10px rgba(0,0,0,0.05)",
            }}
          >
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}
        <div
          className="px-3 w-full dark:!bg-[#141414]"
          style={{ flex: 1, backgroundColor: "#fbf8fc" }}
        >
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />

          {/* Page Header */}
          <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 m-3 border border-[#fbf4ff] dark:!border-[#3c3a3d] flex flex-col gap-y-6">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <h2 className="text-xl font-bold text-[#9e68ba] mb-0">
                  {t("domainSettings.page_title")}
                </h2>
                <p className="text-gray-600 dark:!text-gray-400 mb-0">
                  {t("domainSettings.page_subtitle")}
                </p>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="px-0">
            {/* Domain Cards Section */}
            <div className="w-full px-3 mt-4">
              {(domainStatus.configured || domainStatus.verified) && (
                <DomainCard
                  domain={domainName}
                  existingDomain={existingDomain}
                  domainStatus={domainStatus}
                  revalidateDomains={getDomainStatus}
                  isDelete={true}
                  id={firebaseAccountData.id}
                  refreshPage={getExistingDomain}
                  modification={false}
                />
              )}

              <DomainCard
                domain={firebaseAccountData.storeName}
                domainStatus={{ configured: true }}
                revalidateDomains={() => {}}
                isDelete={false}
                existingDomain=""
                id={firebaseAccountData.id}
                refreshPage={() => {}}
                modification={
                  !(domainStatus.configured || domainStatus.verified)
                }
              />
            </div>

            {/* Domain Configuration Section */}
            {account?.subscription?.plan !== "الأساسية" ? (
              <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 m-3 border border-[#fbf4ff] dark:!border-[#3c3a3d] my-6">
                <div
                  className={`space-y-3 ${isRTL ? "text-right" : "text-left"} `}
                >
                  <h3 className="text-xl font-bold text-[#9e68ba]">
                    {t("domainSettings.section_title")}
                  </h3>

                  {/* Guide message */}
                  {(!domainStatus.configured || !domainStatus.verified) && (
                    <p className="text-gray-600 dark:!text-gray-400">
                      {t("domainSettings.dns_guide_text")}
                      <span
                        type="button"
                        onClick={showModal}
                        className="text-[#9e68ba] hover:text-[#9e68ba] underline cursor-pointer mx-1 dark:!text-[#9e68ba]"
                      >
                        {t("domainSettings.dns_settings_link")}
                      </span>
                    </p>
                  )}

                  {/* Modal */}
                  <Modal
                    title={
                      <h5
                        className={`font-bold text-lg mb-0 ${
                          isRTL ? "text-right" : "text-left"
                        } text-[#9e68ba] dark:!text-[#9e68ba]`}
                      >
                        {t("domainSettings.dns_settings_link")}
                      </h5>
                    }
                    width={500}
                    open={isModalVisible}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    footer={
                      <button
                        type="primary"
                        className="w-full bg-[#9b59bf] hover:bg-[#814a9f] text-white py-2 rounded-lg"
                        onClick={handleOk}
                      >
                        {t("domainSettings.ok")}
                      </button>
                    }
                    closeIcon={
                      <RiCloseFill
                        size={24}
                        className="text-gray-500 dark:!text-gray-400"
                      />
                    }
                    className="dark:!bg-[#181819] "
                  >
                    <div style={rtlStyle} className="mt-4">
                      <ol className="space-y-3 text-gray-700 dark:!text-gray-300">
                        <li>
                          <strong className="text-[#9e68ba] dark:!text-[#9e68ba]">
                            {t(
                              "domainSettings.guide_steps.choose_domain.title"
                            )}
                          </strong>{" "}
                          {t(
                            "domainSettings.guide_steps.choose_domain.description"
                          )}
                        </li>
                        <li>
                          <strong className="text-[#9e68ba] dark:!text-[#9e68ba]">
                            {t(
                              "domainSettings.guide_steps.check_availability.title"
                            )}
                          </strong>{" "}
                          <a
                            href="https://instantdomainsearch.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-[#9e68ba] hover:text-[#9e68ba] dark:!text-[#9e68ba]"
                          >
                            {t(
                              "domainSettings.guide_steps.check_availability.description"
                            )}
                          </a>
                        </li>
                        {/* Autres étapes identiques avec text-gray-700 → dark:!text-gray-300 et text-[#9e68ba] → dark:!text-[#9e68ba] */}
                      </ol>
                    </div>
                  </Modal>
                </div>

                {/* Formulaire Domain */}
                {!(domainStatus.configured || domainStatus.verified) && (
                  <div className="mt-6">
                    <form
                      onSubmit={(e) => e.preventDefault()}
                      className="flex items-center justify-center bg-white dark:!bg-[#141414] rounded-lg p-2 border border-gray-200 dark:!border-[#3c3a3d] focus-within:border-purple-300 focus-within:ring-1 focus-within:ring-purple-300 transition"
                    >
                      <input
                        type="text"
                        onInput={(e) => setDomain(e.target.value)}
                        placeholder={t("domainSettings.form_placeholder")}
                        pattern="^(?:[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9]\.)?[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9]\.[a-zA-Z]{2,}$"
                        required
                        className="text-gray-700  w-full p-2 outline-none dark:!bg-[#181819]"
                      />
                      <button
                        onClick={handleAddDomain}
                        disabled={!domain || adding}
                        className={`py-2 px-6 font-medium text-sm text-center text-white bg-[#9b59bf] hover:bg-[#814a9f] active:bg-purple-800 rounded-lg shadow transition-colors ${
                          !domain || adding
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }`}
                      >
                        {adding ? (
                          <LoadingDots />
                        ) : (
                          t("domainSettings.confirm_button")
                        )}
                      </button>
                    </form>

                    {storeErrorMessage && (
                      <p
                        className={`text-red-500 text-sm mt-2 space-y-3 ${
                          isRTL ? "text-right" : "text-left"
                        }`}
                      >
                        {storeErrorMessage}
                      </p>
                    )}

                    {(!domainStatus.configured || !domainStatus.verified) && (
                      <p className="mt-4 text-center text-sm text-gray-500 dark:!text-gray-400">
                        {t("domainSettings.form_warning1")}
                        <span
                          onClick={showModal}
                          className="text-[#9e68ba] hover:text-[#9e68ba] underline cursor-pointer mx-1 dark:!text-[#9e68ba]"
                        >
                          {t("domainSettings.form_warning2")}
                        </span>
                        {t("domainSettings.form_warning3")}
                      </p>
                    )}
                  </div>
                )}
              </div>
            ) : (
              <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 m-3 border border-[#fbf4ff] dark:!border-[#3c3a3d] my-6">
                <div className="mb-6 bg-yellow-50 dark:!bg-[#3a3212] p-4 rounded-lg border border-yellow-100 dark:!border-[#5c4e1f]">
                  <h4 className="font-medium text-yellow-800 dark:!text-yellow-300 mb-2 text-lg flex items-center">
                    <Info size={18} className="ml-2" />
                    {t("domainSettings.important_notes_title")}
                  </h4>
                  <ul className="text-sm text-gray-700 dark:!text-gray-300 space-y-2 mr-5 list-disc">
                    <li>{t("domainSettings.important_notes.note_1")}</li>
                    <li>{t("domainSettings.important_notes.note_2")}</li>
                    <li>
                      {t("domainSettings.important_notes.note_3")}{" "}
                      <strong className="text-[#9e68ba] dark:!text-[#9e68ba]">
                        {t("domainSettings.important_notes.plan_upgrade")}
                      </strong>
                      .
                    </li>
                    <li>
                      {t("domainSettings.important_notes.note_4")}
                      <br />
                      <span
                        className="text-[#9e68ba] dark:!text-[#9e68ba] font-medium cursor-pointer underline"
                        onClick={goToUpgrade}
                      >
                        {t("domainSettings.important_notes.upgrade_now")}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            )}
            {/* Domain Status Section */}
            <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 m-3 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
              <div className="text-center mb-4">
                <h4 className="text-lg font-bold text-[#9e68ba] dark:!text-[#9e68ba] mb-4">
                  {t("domainSettings.title")}
                </h4>

                {domainStatus.loading ? (
                  <div className="flex items-center justify-center gap-2 text-gray-600 dark:!text-gray-300">
                    <span className="inline-block h-4 w-4 rounded-full border-2 border-t-purple-600 border-purple-200 animate-spin"></span>
                    <p>{t("domainSettings.loading")}</p>
                  </div>
                ) : domainStatus.configured && domainStatus.verified ? (
                  <div className="bg-green-50 dark:!bg-green-900 text-green-800 dark:!text-green-300 p-3 rounded-lg flex items-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 mr-2"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <p className="font-semibold">
                      {t("domainSettings.success")}
                    </p>
                  </div>
                ) : domainStatus.configured ? (
                  <div className="bg-yellow-50 dark:!bg-yellow-900 text-yellow-800 dark:!text-yellow-300 p-3 rounded-lg flex items-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 mr-2"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <p className="font-semibold">
                      {t("domainSettings.configured_not_verified")}
                    </p>
                  </div>
                ) : (
                  <div className="bg-red-50 dark:!bg-red-900 text-red-800 dark:!text-red-300 p-3 rounded-lg flex items-center justify-center">
                    <AlertCircle size={20} className="mr-2" />
                    <p className="font-semibold">
                      {t("domainSettings.not_configured")}
                    </p>
                  </div>
                )}
              </div>

              {/* DNS Records Table */}
              {(!domainStatus.configured || !domainStatus.verified) && (
                <div className="mt-6">
                  <div className="flex items-center justify-center mb-3 text-red-600 dark:!text-red-400 gap-2">
                    <AlertCircle size={18} />
                    <p className="text-sm font-medium">
                      {t("domainSettings.dns_section.alert")}
                    </p>
                  </div>
                  <div className="max-w-2xl mx-auto">
                    <Table
                      dataSource={dataSource}
                      columns={columns}
                      pagination={false}
                      rowClassName={() =>
                        "dark:!bg-[#181819] dark:!text-gray-300"
                      }
                      className="border border-gray-200 dark:!border-[#3c3a3d] rounded-lg shadow-sm bg-white dark:!bg-[#181819]"
                      style={{ direction: "ltr" }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>

          <Footer />
        </div>
      </div>
    </div>
  );
}
